
import {
  validationHandlerEmailProfile,
  validationHandlerPassword,
} from "../helpers/fieldsHandler";
import { errorAuthHandler } from "../helpers/errorsHandler";
import jwt_decode from "jwt-decode";

export default {
  name: "PageSignIn",
  data() {
    return {
      fields: {
        email: null,
        password: null,
      },
      errors: {
        emailErrorMessages: "",
        passwordErrorMessages: "",
      },
      alert: {
        show: false,
        text: "",
      },
    };
  },
  computed: {
    validateEmail: function () {
      return validationHandlerEmailProfile(this.fields.email);
    },
    validatePassword: function () {
      return validationHandlerPassword(this.fields.password);
    },
  },
  methods: {
    async submitForm(e) {
      e.preventDefault();
      if (this.validateEmail.length < 1 && this.validatePassword.length < 1) {
        try {
          const { data } = await this.$axios.post(
            "/customers/login",
            { email: this.fields.email, password: this.fields.password },
            { withCredentials: true }
          );
          if (data.user) {
            this.$store.commit("setUser", data.user);
            this.$store.commit("login");
            this.$router.push("/");
          }
        } catch (e) {
          this.alert.show = true;
          this.alert.text = errorAuthHandler(e.message);
        }
      } else {
        this.errors.emailErrorMessages = this.validateEmail;
        this.errors.passwordErrorMessages = this.validatePassword;
      }
    },
    focusoutEmailInput() {
      this.errors.emailErrorMessages = this.validateEmail;
    },
    focusoutPasswordInput() {
      this.errors.passwordErrorMessages = this.validatePassword;
    },
    async googleAuth(input) {
      console.log(input);
      try {
        const { data } = await this.$axios.post(
          "/customers/google-login",
          { idToken: input.credential },
          { withCredentials: true }
        );
        console.log(data);
        if (data.user) {
          this.$store.commit("setUser", data.user);
          this.$store.commit("login");
          this.$router.push("/");
        }
      } catch (e) {
        console.log(e);
        this.alert.show = true;
        this.alert.text = errorAuthHandler(e.message);
      }
    },
    async initGoogleBtn(count = 10) {
      this.$nextTick(async () => {
        if (this.$refs.googleBtn) {
          try {
            await google.accounts.id.initialize({
              client_id: this.$config.googleAuthClientId,
              callback: this.googleAuth,
              context: "signin",
            });
            google.accounts.id.renderButton(this.$refs.googleBtn, {
              type: "standard",
              size: "large",
              text: "signin_with",
              shape: "rectangular",
              logo_alignment: "center",
              width: 408,
            });
          } catch (error) {
			console.log(error)
		  }
        } else if (count > 0) {
          this.initGoogleBtn(count - 1);
        }
      });
    },
  },
  async mounted() {
    await this.initGoogleBtn();
  },
};
